import { FormUtils } from '../../../utils'
import { TicketSizeFormData } from './types'

export type TicketSizeValidation = FormUtils.FormValidation<TicketSizeFormData>

const creationValidator: FormUtils.DataValidatorFn<TicketSizeFormData> = (key, value, data) => {
    switch (key) {
        case 'size': {
            if (typeof value !== 'string' || value.trim().length === 0) {
                return 'ticket-size-validation-size'
            }
            return
        }
        case 'start_date':
        case 'end_date': {
            if (value && data.end_date < data.start_date) {
                return 'ticket-size-validation-date-end-switched'
            }
            return
        }
        case 'skus': {
            if (!value || (Array.isArray(value) && value.length === 0)) {
                return 'ticket-size-validation-skus-empty'
            }
            return
        }
        default:
            return
    }
}

function validateCreation(ticketSizeData: TicketSizeFormData) {
    return FormUtils.validate(ticketSizeData, creationValidator)
}

function validateUpdate(ticketSizeData: TicketSizeFormData) {
    return FormUtils.validate(ticketSizeData, creationValidator)
}

export { validateCreation, validateUpdate }
